var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock-wrapper d-flex align-items-center justify-content-center",style:({color:_vm.color})},[_c('div',{staticClass:"showClock",style:({color:_vm.color,fontSize:`${_vm.fs}px`})},[_vm._v(" "+_vm._s(_vm.format === "24" ? _vm.fullFormat : _vm.halhFormat)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }